// import { Modal, Button } from "antd";
import "./AntdModal.css";  

import React from "react";
import { Modal, Button } from "antd";
import { color } from "framer-motion";

const AntdModal = ({
  isVisible,
  onClose,
  onConfirm,
  onTertiary,
  // modalClassName = "styled-modal",
  modalClassName="styled-modal",
  hideSecondaryBtn = false,
  modalTitleHeading,
  secondaryBtnText,
  primaryBtnText,
  tertiaryBtnText,
  disableConfirmButton,
  disableTertiryBtn,
  children,
  primaryBtnLoading,
  primaryBtnDisabled,
  hideBtns = false,
  width
}) => {
  const titleNode = (
    
      <div style={{ fontWeight: 600 }}>{modalTitleHeading}</div>
    
  );

  return (
    <Modal
      width={width}
      title={titleNode}
      style={{ top: 40 }}
      open={isVisible}
      onCancel={onClose}
      className={modalClassName}                     // → styled-modal
      wrapClassName={`${modalClassName}-wrap`}  
      styles={{
        body: {
          maxHeight: "70vh",
          overflowY: "auto",
          padding: 24,
        },
      }}
      footer={
        hideBtns
          ? null
          : [
              !hideSecondaryBtn && (
                <Button key="cancel" onClick={onClose}>
                  {secondaryBtnText}
                </Button>
              ),
      
              tertiaryBtnText && onTertiary && (
                <Button
                  key="tertiary"
                  disabled={disableTertiryBtn}
                  type="default"
                  onClick={onTertiary}
                >
                  {tertiaryBtnText}
                </Button>
              ),
      
              primaryBtnText && onConfirm && (
                <Button
                  key="confirm"
                  type="primary"
                   loading={primaryBtnLoading}
                   disabled={primaryBtnDisabled}
                  onClick={onConfirm}
                  // disabled={disableConfirmButton}
                >
                  {primaryBtnText}
                </Button>
              )
            ]
      }
      
    >
      {children}
    </Modal>
  );
};

export default AntdModal;